import { api } from "./client";
import type { Gender, MeResponse } from "./types";

export interface AuthPayload {
  email: string;
  password: string;
}

export interface RegisterPayload extends AuthPayload {
  fullName: string;
  phone?: string;
  /** Wajib: sistem memilih terapis dengan jenis kelamin yang sama. */
  gender: Gender;
}

export function fetchMe() {
  return api.get<MeResponse>("/auth/me");
}

/** Apakah login Zetri SSO diaktifkan di server (tombol di halaman masuk). */
export function ssoStatus() {
  return api.get<{ enabled: boolean }>("/auth/sso/status");
}

export function login(payload: AuthPayload) {
  return api.post<MeResponse>("/auth/login", payload);
}

export function register(payload: RegisterPayload) {
  return api.post<{ user: MeResponse["user"] }>("/auth/register", payload);
}

export function updateProfile(payload: { gender: Gender }) {
  return api.patch<{ user: MeResponse["user"] }>("/auth/me", payload);
}

export function logout() {
  return api.post<{ ok: boolean }>("/auth/logout");
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export function changePassword(payload: ChangePasswordPayload) {
  return api.post<{ ok: boolean }>("/auth/change-password", payload);
}
